import { useEffect } from 'react';

const useSavePrevent = () => {
  useEffect(() => {
    const ids = ['companySetup'];

    const anyElementExists = () =>
      ids.some(id => document.getElementById(id) !== null);

    const handleKeyDown = (e) => {
      if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === 's'&& anyElementExists()) {
        e.preventDefault();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, []);
};

export default useSavePrevent;
